import { defineStore } from 'pinia'
import { fetchAppConfigStatus } from '~/composables/api'
import { STORE_ID } from '~/constants/store'
import type { AppStatusState as State } from '~/types/appStatus'
const initialState = (): State => ({
  updateRequired: false,
  updateAlertContent: undefined,
  lastChecked: 0,
  isChecking: false
})

/**
 * @name useAppStatusStore
 * @description Store for app status state across the app
 *
 */
const useAppStatusStore = defineStore(STORE_ID.APP_STATUS, {
  state: initialState,

  getters: {},
  actions: {
    async checkAppVersion() {
      const cacheDuration = 5 * 60 * 1000 // 5 minutes in milliseconds
      const now = Date.now()

      if (this.isChecking || now - this.lastChecked < cacheDuration) {
        return
      }

      this.isChecking = true
      try {
        const response = await fetchAppConfigStatus()
        if (response && response.versionUpdate?.isRequired) {
          this.updateRequired = true
          this.updateAlertContent = response.versionUpdate.alertContent
        } else {
          this.updateRequired = false
          this.updateAlertContent = undefined
        }
      } catch (error) {
        console.warn('Failed to get app version status:', error)
        this.updateRequired = false
        this.updateAlertContent = undefined
      } finally {
        this.isChecking = false
        this.lastChecked = now
      }
    }
  }
})

export default useAppStatusStore
export { initialState }
